module.exports = __webpack_public_path__ + "static/media/pokepoke_logo_white.529773ca.png";